export class DefaultCorrespondent {
    CorrespondentId: number;
    IsAgent: boolean;
}


export class Correspondent {
    CorrespondentId: number;
    IsAgent: boolean;
    Name: string;
    Gender: string;
    RelationshipCode: string;
    RelationshipTypeName: string;
    MobileCountryCode: string;
    MobilePhoneNumber: string;
    HomeCountryCode: string;
    HomePhoneNumber: string;
    EmailAddress: string;
    AddressLine1: string;
    AddressLine2: string;
    Suburb: string;
    State: string;
    Postcode: string;
    Country: string;
    IsDefault: boolean;
    DisableForSelection: boolean;
    AgentNote: string;
}
